export const saveStorage = (keyName: string, value: string) => {
    return window?.sessionStorage?.setItem(keyName, value || '');
};

export const getStorage = (keyName: string) => {
    return window?.sessionStorage?.getItem(keyName);
};
